export default {
  subtitle: "",
  path: "notification_card_transaction_approved",
  paragraph: "We also have specific webhooks for card related transactions. The following webhook will be received when a card payment has been approved for a card transaction: ",
  request: {
    method: "POST", 
    payloads: [
		{
			title: "Notification",
			content: { 
			 "notification": { 
        "type": "payment_approved", 
        "transaction_id": "bfb7a294-89ad-4a9e-a221-5e9c499a05f0",
        "checkout_id": "80c675cc-5a68-4023-87a3-faf13401d424",
        "secret": "the value you received"
				}
			 }
		  }
		]
  },
  parameterPayload: [
    {
      name: "notification",
      type: "object",
      required: true,
      description: "An object containing all the required values needed"
    },
    {
      name: "notification.type",
      type: "string",
      required: true,
      description: "Type of the notification. In this case, it will always be \"payment_approved\""
    },
    {
      name: "notification.transaction_id",
      type: "string",
      required: true,
      description: "ID of the transaction"
    },
    {
      name: "notification.checkout_id",
      type: "string",
      required: false,
      description: "ID of the checkout page. It will only be sent if the transaction was created using the checkout page API"
    },
    {
      name: "notification.secret",
      type: "string",
      required: true,
      description: "The secret you set when you register your webhook by using the \"Enabling webhooks\" endpoint"
    }
  ]
}
  


// WEBPACK FOOTER //
// ./src/components/documentation/data/WebHook/NotificationCardTransactionApproved.js